import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        property_categories: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {}
            }
        },
        has_errors: false,
        loading:false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        loading: state => state.loading,
        property_categories: state => state.property_categories,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setLoading(state, data) {
            state.loading= data;
        },
        setPropertyCategories(state, data) {
            state.property_categories = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {}
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getPropertyCategories({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getPropertyCategories(filters);
                commit('setPropertyCategories', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

        async createPropertyCategories({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createPropertyCategories(data);
                ElMessage.success('property category created successfully!');
                commit('setDialogVisible',false)
                dispatch('getPropertyCategories', {
                    paginate: true
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating property category!');
            }
        },
        async editPropertyCategories({dispatch, commit}, data) {
            try {
                await api.editPropertyCategory(data);
                ElMessage.success('property category updated successfully!');
                commit('setDialogVisible',false)
                dispatch('getPropertyCategories', {
                    paginate: true
                })
            } catch (e) {
                ElMessage.error('Error updating property category');
            }
        },
        async deletePropertyCategories({commit,dispatch}, data) {
            commit('setLoading', true);
            try {
                const response = await api.deletePropertyCategory(data);
                commit('setLoading', false);
                dispatch('getPropertyCategories', {
                    paginate: true
                })
                if (response.status === 401) {
                    ElMessage.warning({
                        message:response.message,
                        duration:10000
                    });
                } else {
                    ElMessage.success({
                        message:response.message,
                        duration:10000
                    });
                }
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

    }
}
